module.exports = __webpack_public_path__ + "img/RECUADRO_Capacitacion.21f3ad84.png";